import Swiper, { Autoplay, Navigation } from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Autoplay, Navigation]);


document.addEventListener('DOMContentLoaded',function() {

    const travel = document.getElementsByClassName('js-travelslider')[0],
          reviews = document.getElementsByClassName('js-reviewsslider')[0];

    window.reviewsSlider = function() {

	    const swiper = new Swiper(reviews, {
    	    autoHeight: true,
    	    freeMode: true,
    	    navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
    	    slidesPerView: 'auto',
	    });
    };

    window.travelSlider = function() {

	    const swiper = new Swiper(travel, {
    	    autoHeight: false,
    	    navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
    	    slidesPerView: 1,
    	    freeMode: true,
    	    breakpoints: {
                510: {
                    freeMode: false,
                    slidesPerView: 2,
                    spaceBetween: 10
                },

                769: {
                    autoHeight: true,
                    slidesPerView: 3,
                    spaceBetween: 0
                },
            },
	    });
    };

}, false)
